import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import { IResponseCompany } from '~/utils/interface/company';

const url = `api/admin/companies`;

const companyApi = {
  getSelectCompany() {
    return axiosClient.get<IApiBaseResponse<IResponseCompany>>(url);
  },
};

export default companyApi;
